function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { StyledTBody } from "./TBody";
import { grey2, highlightBlue, highlightAmber, highlightCyan, highlightGreen, highlightMagenta, highlightRed, highlightViolet, highlightYellow, white } from "@churchofjesuschrist/eden-style-constants";
import { useRowSelectionContext } from "./rowSelection/context";
import { Context } from "./settings/context";
const highlights = {
  amber: highlightAmber,
  blue: highlightBlue,
  cyan: highlightCyan,
  green: highlightGreen,
  magenta: highlightMagenta,
  red: highlightRed,
  violet: highlightViolet,
  yellow: highlightYellow
};
const StyledTR = styled.tr.withConfig({
  componentId: "sc-zkgtp5-0"
})(["background-color:", ";", " &&{background-color:", ";&:nth-child(odd){background-color:", ";}}"], white,
/* sc-selector */
StyledTBody, ({
  highlighted,
  highlightColor = highlightBlue
}) => highlighted ? `${highlightColor} !important` : white, ({
  striped
}) => striped ? grey2 : white);

const TR = ({
  children,
  highlightColor = "blue",
  selectionRow,
  highlighted,
  ...props
}) => {
  const {
    values = [],
    RowSelectionCell
  } = useRowSelectionContext();
  const {
    striped
  } = useContext(Context);
  return /*#__PURE__*/React.createElement(StyledTR, _extends({}, props, {
    striped: striped,
    highlighted: values.includes(selectionRow) || highlighted,
    highlightColor: highlights[highlightColor]
  }), RowSelectionCell && /*#__PURE__*/React.createElement(RowSelectionCell, {
    row: selectionRow
  }), children);
};

export { StyledTR };
export default TR;
TR.propTypes = {
  /** The row contents. */
  children: PropTypes.node,

  /** Whether the row is highlighted. */
  highlighted: PropTypes.bool,

  /** The hightlight color to apply when `highlighted` is true. */
  highlightColor: PropTypes.oneOf(["amber", "blue", "cyan", "green", "magenta", "red", "violet", "yellow"]),

  /** The row key for when the `Table` has `rowSelection`. */
  selectionRow: PropTypes.string
};